const API_BASE = import.meta.env.VITE_API_URL ?? '';

export class ApiError extends Error {
  constructor(
    message: string,
    public readonly status: number,
  ) {
    super(message);
  }
}

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const requestInit: RequestInit = { credentials: 'include', ...(init ?? {}) };
  if (init?.body !== undefined && !(init.body instanceof FormData)) {
    const headers = new Headers(init?.headers);
    headers.set('Content-Type', 'application/json');
    requestInit.headers = headers;
  }
  const response = await fetch(`${API_BASE}${path}`, requestInit);
  if (response.status === 413) throw new ApiError('文件过大，最大支持 10MB', response.status);
  const body = (await response.json().catch(() => ({ error: '响应格式错误' }))) as T & {
    error?: string;
  };
  if (!response.ok)
    throw new ApiError(body.error ?? `请求失败 (${response.status})`, response.status);
  return body;
}

export const postJson = <T>(path: string, body?: unknown) =>
  api<T>(path, { method: 'POST', body: JSON.stringify(body ?? {}) });
export const patchJson = <T>(path: string, body: unknown) =>
  api<T>(path, { method: 'PATCH', body: JSON.stringify(body) });
export const putJson = <T>(path: string, body: unknown) =>
  api<T>(path, { method: 'PUT', body: JSON.stringify(body) });
export const deleteJson = <T>(path: string) => api<T>(path, { method: 'DELETE' });
